import { SettingsEthernet } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";

const styles = () => {
  return {
    height: "32px",
    position: "relative",
    "& .off-line": {
      position: "absolute",
      top: "-6px",
      left: "5px",
      fontSize: "30px",
      transform: "rotate(135deg)",
    },
  };
};

const EthernetIcon = React.forwardRef((props, ref) => {
  const { configured } = props;
  return (
    <Box {...props} ref={ref} sx={styles}>
      <SettingsEthernet className="wizard-status-child ethernet-icon" />
      {!configured && <Box className="off-line">/</Box>}
    </Box>
  );
});

export default EthernetIcon;
